<template lang='pug'>
	.home-pleca-contenido-blanco
		.contenedor-pleca-contenido
			.contenido
				.modulo.m1
					.img
						img(src='~Img/home-house.png')
				.modulo.m2
					h2(name="last-h1")
						| Full Service Consulting
					p.caja-texto1
						| Just want to get it done quickly, at a reasonable price, with a minimum of fuss?
						br
						br
						| In here you can find out what information to send and how to send it. CAD drawings happily accepted by e-mail or through our upload link.
					router-link.btn(to='/full-service')
						span
							| Read more
</template>

<script>
export default {
	name: 'plecaBlanca'
}
</script>



// WEBPACK FOOTER //
// src/components/home/PlecaBlanca.vue